import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "./contexts/AuthContext";

const PublicRoute = ({ element: Component }) => {
  const { user } = useContext(AuthContext);

  //return user ? <Navigate to="/contact-us-details" replace /> : <Component />;
   return user ? <Navigate to="/" replace /> : <Component />;
};

export default PublicRoute;
